import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, Grid } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from "../../components/Common/DeleteModal";
import Notification from "../../components/Common/Notification";
import Helpers from "../../helpers/helpers";

import "./report.css"
import LoadingDialog from "../../components/Common/LoadingDialog";
import { exportSalesReport, getAnnualReportExport, getSalesReport, resetReportAttachmentState, resetReportState } from "../../store/actions";
import SearchBar from "../../components/Common/Searchbar";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import CustomButton from "../../components/Form/CustomButton";
import CustomDateRangePicker from "../../components/Form/CustomDateRangePicker";
import moment from "moment";
import { Icon } from "@iconify/react/dist/iconify.js";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";

const SalesReport = ({ userPermission, salesReportDocument, salesReportListing }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(resetReportState());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [loading, setLoading] = useState(false);
    const [platformFilter, setPlatformFilter] = useState("0");
    const [statusFilter, setStatusFilter] = useState("0");
    const [sort_by, setSortBy] = useState('sales_date');
    const [dateModalOpen, setDateModalOpen] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [dateRange, setDateRange] = useState([null, null]);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [sort, setSorted] = useState("desc")
    const [exportable, setExportable] = useState(false);
    const [viewable, setViewable] = useState(false);

    const [content, setContent] = useState({
        open: false,
        title: "",
        msg: "",
        buttonTitle: "",
        action: "",
        id: "",
    })

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const platformList = [
        { value: "0", label: "All platforms" },
        { value: "aspeed", label: "Aspeed" },
        { value: "ariba", label: "Ariba" },
    ]

    useEffect(() => {
        initData();
    }, [page, length, sort_by, sort, startDate, endDate, platformFilter, statusFilter])

    useEffect(() => {
        if (salesReportDocument?.code === 'success' && salesReportDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(salesReportDocument.excel_base64, 'sales_report_listing');
            dispatch(resetReportAttachmentState());
        }
        setLoading(false);
    }, [salesReportDocument])

    const initData = () => {
        dispatch(getSalesReport({
            page: page,
            length: length,
            sort_order: sort,
            sort: sort_by,
            from_date: startDate,
            to_date: endDate,
            platform: platformFilter,
            status: statusFilter === "0" ? '' : statusFilter
        }));
    }

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("export-reporting") && setExportable(true);
            userPermission?.includes("view-reporting") && setViewable(true);
            !userPermission?.includes("view-reporting") && navigate('/not-authorized');
        }
    }, [userPermission])

    const handleSetDateRange = (e) => {
        setPage("1");
        if (e) {
            setDateRange(e);
            setStartDate(moment(e[0]).format('YYYY-MM-DD'));
            setEndDate(moment(e[1]).format('YYYY-MM-DD'));
        } else {
            setDateRange(null);
            setStartDate(null);
            setEndDate(null);
        }
    }

    const handleExport = () => {
        let filter = {
            sort_order: sort,
            sort: sort_by,
            created_date_from: startDate,
            created_date_to: endDate,
            sales_platform: platformFilter,
            status: statusFilter
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all' || filter[key] === "0") {
                delete filter[key];
            }
        });
        setLoading(true);
        dispatch(exportSalesReport(filter));
    }

    const resetFilter = () => {
        setPage("1");
        setDateRange([]);
        setStartDate(null);
        setEndDate(null);
        setPlatformFilter('0');
        setStatusFilter('0');
    }

    const header = [
        {
            Header: "Sales date ",
            columnID: "sales_date",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div style={{ paddingRight: "5px" }}>{cellProps?.sales_date || '-'}</div>
                    </React.Fragment>
                )
            },
            minWidth: 150,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Order",
            columnID: "id",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <Link className="clickable-text" to={`/view-order/${cellProps?.platform && cellProps.platform.toLowerCase()}/${cellProps?.id}`} >#{cellProps?.id || '-'}</Link>
                        <div>{cellProps?.total_item_count || '0'} items</div>
                    </React.Fragment>
                )
            },
            minWidth: 150,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Platform",
            columnID: "sales_platform",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.platform || '-'}</div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Customer",
            columnID: "customer",
            accessor: (cellProps) => {
                return (
                    <div>
                        <Link className="clickable-text" to={`/edit-customer/${cellProps?.customer_id}`} >{cellProps?.customer_name || '-'}</Link>
                        <div>{cellProps.customer_email}</div>
                    </div>
                )
            },
            minWidth: 150,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Sales before discount (S$)",
            columnID: "subtotal",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.subtotal || '0.00'}</div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Sales after discount & refund (S$)",
            columnID: "total",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.total || '0.00'}</div>
                )
            },
            disableFilters: true,
            filterable: false,
        }
    ]

    const settingCategoryButton = (iconName, title, subtitle, value, isMoney = false) => {
        return (
            <Grid item lg={4} md={6} sm={12} xs={12} display={'flex'}>
                <div className="summary-card-container">
                    <Grid container className="d-flex align-self-center p-3 px-2" textAlign={'left'} spacing={2}>
                        <Grid item lg={2} md={2.3} textAlign={'center'}>
                            <Icon icon={iconName} fontSize={45} style={{ color: '#D0D0D0' }} />
                        </Grid>
                        <Grid item lg={10} md={9.7}>
                            <div className="setting-header">{title}</div>
                            <div className="summary-card-subtitle">{subtitle}</div>
                            <div className="summary-card-value mt-2">{isMoney ? `S$ ${value || '0.00'}` : (value || '0')}</div>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        )
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={10} md={12} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={4} md={4} xs={12}>
                        <CustomDateRangePicker
                            open={() => setDateModalOpen(true)}
                            close={() => setDateModalOpen(false)}
                            isOpen={dateModalOpen}
                            startDate={(startDate && moment(startDate).format('DD MMM YYYY')) || 'dd/mm/yyyy'}
                            endDate={(endDate && moment(endDate).format("DD MMM YYYY")) || 'dd/mm/yyyy'}
                            handleSetDateRange={handleSetDateRange}
                            value={dateRange}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={platformFilter || "-1"}
                            onChange={(e) => { setPage("1"); setPlatformFilter(e) }}
                            data={platformList}
                            placeholder={"Platform"}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={statusFilter || "-1"}
                            onChange={(e) => {setPage("1"); setStatusFilter(e)}}
                            data={Helpers.statusList}
                            placeholder={"Status"}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item lg={2} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content textColor" style={{ minHeight: 850 }}>
                <LoadingDialog open={loading} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <DeleteModal setContent={setContent} content={content} />
                    <div className="header mb-1">Sales Report</div>
                    {customToolsBar()}
                    <Grid container spacing={2} marginBottom={3}>
                        {settingCategoryButton('solar:diagram-up-bold-duotone', 'Sales', `${platformFilter !== "0" ? platformFilter.charAt(0).toUpperCase() + platformFilter.slice(1) : 'All'} platforms sales`, salesReportListing?.total_sales, true)}
                        {settingCategoryButton('solar:wad-of-money-bold-duotone', 'Number of transactions', `${platformFilter !== "0" ? platformFilter.charAt(0).toUpperCase() + platformFilter.slice(1) : 'All'} platforms sales`, salesReportListing?.total_transactions)}
                        {settingCategoryButton('solar:cart-large-2-bold-duotone', 'Average order value', `${platformFilter !== "0" ? platformFilter.charAt(0).toUpperCase() + platformFilter.slice(1) : 'All'} platforms sales`, salesReportListing?.average_order_value, true)}
                    </Grid>
                    <Table
                        header={header}
                        data={salesReportListing?.data || []}
                        getLengthPage={getLengthPage}
                        pageSize={length}
                        totalPage={salesReportListing?.pagination?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={salesReportListing?.pagination?.last_page || 1}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps({ Report, Login }) {
    return {
        salesReportListing: Report.salesReportListing?.data,
        salesReportDocument: Report.salesReportDocument,
        userPermission: Login.permissionArry,
    };
}

export default connect(mapStateToProps)(SalesReport);
